import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Modal extends Component {
  handleCloseClick() {
    this.context.showModal(false, '');
  }

  render() {

		let config = Object.assign({}, {className: [], style: {}}, this.props.config);
		config.className.push('imageframe-modal');

    return (
      <div className="modal-container">
        <div className={config.className.join(' ')} style={config.style}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

Modal.contextTypes = {
  showModal: PropTypes.func
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js